import React from 'react'

import { API } from 'services';
import { Auth } from 'services';

import { AbstractContainer } from 'containers';

import { ClinicExamenListScene } from 'scenes';

class ClinicExamenListContainer extends AbstractContainer {

  getTasks() {

    let clinic = Auth.getManagedClinic();

    return [
      {
        key: 'examens',
        exec: (done, failure) => {
          API.get(`/clinics/${clinic.id}/examens`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <ClinicExamenListScene examens={results.examens} />
  }
}

export default ClinicExamenListContainer;
